import {
    Box,
    Button,
    CrudMode,
    DataArray,
    DataDisplay,
    Grid,
    GridBreak,
    pn,
    Stack,
    useElementBreakpoints,
    ValidationErrors,
} from "@compass/core";
import { Input, Select } from "components";
import { FeederSchoolEditResource, FeederSchoolViewResource, FeederSchool } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const FeederSchoolPageBody = (props: {
    crudMode: CrudMode;
    feederSchool: FeederSchool;
    setFeederSchool: (value: FeederSchool) => void;
    viewResource: FeederSchoolViewResource;
    editResource: FeederSchoolEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints, fullFieldBreakpoints } =
        useElementBreakpoints();
    const properties = props.viewResource.properties || [];

    const nameField = () => {
        const propertyName = pn<FeederSchool>("name");
        const property = properties.find((x) => x.propertyName === propertyName);
        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.feederSchool.name}</DataDisplay>
        ) : (
            <Input
                modelProperty={property}
                errors={props.validationErrors[propertyName]}
                value={props.feederSchool.name}
                onChange={(e) =>
                    props.setFeederSchool(
                        produce(props.feederSchool, (draft) => {
                            draft.name = e.target.value;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={smallFieldBreakpoints}>
                {nameField()}
            </Grid>
            <GridBreak />
        </Grid>
    );
};